function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import Button from "segments/desktop/core-components/button/button";
import { XS, XXS } from "constants/sizes";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import DefaultProps from "./default-props";
import { StyledSideBySideWithIconsTextAndAssetMobileComponent } from "./side-by-side-with-icons-text-and-asset-mobile-component.scss.js";
const SideBySideWithIconsTextAndAssetMobileComponent = (props)=>{
    const { iconsConfig, asset, fullParagraph, mobileMarginBetweenAssetAndButton, mobileMarginUnderButton } = props;
    const { buttonConfig } = fullParagraph, fullParagraphRest = _object_without_properties(fullParagraph, [
        "buttonConfig"
    ]);
    return /*#__PURE__*/ _jsxs(StyledSideBySideWithIconsTextAndAssetMobileComponent, {
        className: "side-by-side-with-icons-text-and-asset-mobile-component",
        style: {
            "--margin-between-asset-and-button": mobileMarginBetweenAssetAndButton
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "full-paragraph",
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraphRest), {
                    textAlign: "center",
                    titleSize: XS,
                    textSize: XXS,
                    iconsConfig: iconsConfig
                }))
            }),
            /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset)),
            /*#__PURE__*/ _jsx("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
            })
        ]
    });
};
SideBySideWithIconsTextAndAssetMobileComponent.defaultProps = DefaultProps;
export default SideBySideWithIconsTextAndAssetMobileComponent;
